import React, { ReactElement } from 'react';
import { uniqueId } from 'lodash';
import { AttributesInterface, Option } from '../../admin-dashboard-tables/interfaces';
import { SortByProps } from '../../widgets/sorts/SimpleSortBy';
import WrapperlessSellerAdsTable from './WrapperlessSellerAdsTable';

interface Props {
  query?: string,
  customHits: JSX.Element,
  attributes: Array<AttributesInterface>,
  bulkActions?: Array<Option>,
  setHits?: (hits: Array<number>) => void,
  setBulkAction?: (action: Option) => void,
  bulkAction?: Option,
  useCards?: boolean,
  allowSetHitsPerPage?: boolean,
  title?: string,
  titleClass?: string,
  tableWrapperClass?: string,
  onQueryUpdateCallback?: (query: string) => void,
  setPage: (page: number) => void,
  BulkSelector?: React.JSXElementConstructor<any>|ReactElement,
  searchResults: {
    page: number,
    hitsPerPage: number,
    nbPages: number,
    nbHits: number,
  },
  onReset?: () => void,
  onChangeHitsPerPage: (hitsPerPage: number) => void,
  sortByOptions?: SortByProps,
}

const SellerAdsWidget: React.FC<Props> = ({
  query,
  setBulkAction,
  bulkAction,
  customHits,
  attributes,
  bulkActions,
  setHits,
  allowSetHitsPerPage,
  setPage,
  title,
  titleClass,
  tableWrapperClass,
  onQueryUpdateCallback,
  BulkSelector,
  searchResults,
  onReset,
  onChangeHitsPerPage,
  sortByOptions,
}) => {
  const wrapperId = uniqueId('seller-ads-widget');

  return (
    <div
      className="bg-white p-3 p-sm-4 shadow"
      id={wrapperId}
    >
      {title && (<p className={titleClass || ''}>{title}</p>)}
      <div className={tableWrapperClass}>
        <WrapperlessSellerAdsTable
          onChangeHitsPerPage={onChangeHitsPerPage}
          query={query || ''}
          customHits={customHits}
          attributes={attributes}
          onReset={onReset}
          setBulkAction={setBulkAction}
          bulkAction={bulkAction}
          bulkActions={bulkActions}
          ExternalBulkSelector={BulkSelector}
          setHits={setHits}
          allowSetHitsPerPage={allowSetHitsPerPage}
          setPage={setPage}
          onQueryUpdateCallback={onQueryUpdateCallback}
          searchResults={searchResults}
          scrollPage={() => {
            const element = document.getElementById(wrapperId);
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              });
            }
          }}
          clearBulkSelected={() => {}}
          sortByOptions={sortByOptions}
        />
      </div>
    </div>
  );
};

SellerAdsWidget.defaultProps = {
  BulkSelector: (<></>),
  attributes: [],
  tableWrapperClass: 'ads-table',
  allowSetHitsPerPage: true,
};

export default SellerAdsWidget;
